import { useCallback, useEffect, useState } from 'react';
import { clearPinSession, loadPinSession, savePinSession, type PinSession } from './session';

const EVT = 'qargo.pin.session.change';

/**
 * Read/write hook for the active PIN session. Returns the current session or
 * null, plus setters for login/logout. Multiple components reading the same
 * session stay in sync via a window-level CustomEvent.
 */
export function usePinSession() {
  const [session, setSession] = useState<PinSession | null>(() => loadPinSession());

  useEffect(() => {
    const onChange = () => setSession(loadPinSession());
    window.addEventListener(EVT, onChange);
    return () => window.removeEventListener(EVT, onChange);
  }, []);

  const login = useCallback((next: PinSession) => {
    savePinSession(next);
    setSession(next);
    window.dispatchEvent(new CustomEvent(EVT));
  }, []);

  const logout = useCallback(() => {
    clearPinSession();
    setSession(null);
    window.dispatchEvent(new CustomEvent(EVT));
  }, []);

  return { session, login, logout };
}
